/**
 * Sınıf adlarını birleştiren yardımcı fonksiyon (shadcn cn benzeri)
 * @param {...(string|string[]|undefined|null|false)} inputs
 * @returns {string}
 */
export function cn(...inputs) {
  return inputs
    .flat()
    .filter((x) => x != null && x !== false && typeof x === 'string')
    .join(' ');
}
